import { Link } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";

interface StoriesEmptyStateProps {
    search: string;
    onClearSearch: () => void;
}

export function StoriesEmptyState({ search, onClearSearch }: StoriesEmptyStateProps) {
    return (
        <Card className="p-12">
            <div className="text-center space-y-4">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                    <BookOpen className="h-8 w-8 text-primary" />
                </div>
                <h2 className="text-2xl font-bold">No Stories Yet</h2>
                <p className="text-muted-foreground max-w-md mx-auto">
                    {search
                        ? `No stories found matching "${search}". Try a different search term.`
                        : "Start your first adventure in Story Mode!"}
                </p>
                {!search && (
                    <Button asChild>
                        <Link to="/story-mode">Create Your First Story</Link>
                    </Button>
                )}
                {search && (
                    <Button
                        variant="outline"
                        onClick={onClearSearch}
                        className="hover:text-primary hover:border-primary"
                    >
                        Clear Search
                    </Button>
                )}
            </div>
        </Card>
    );
}
